module.exports = __webpack_public_path__ + "static/media/React95Video-Numbers.f6ed9192.ttf";